import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40a816d6")

_pushScopeId("data-v-40a816d6")
const _hoisted_1 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_2 = {
  class: "flex-grow-1 card-p pb-0",
  style: {"background":"{{ background }}"}
}
const _hoisted_3 = { class: "d-flex flex-wrap align-items-start justify-content-between" }
const _hoisted_4 = { class: "d-flex flex-wrap align-items-center w-75" }
const _hoisted_5 = { class: "ml-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card order-widget"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_ctx.getKey)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: [`text-${_ctx.chartColor}`, "fw-bolder main-content"]
                  }, _toDisplayString(_ctx.getKey), 3))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-7-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "bar",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
})